import PropTypes from 'prop-types'
import { ButtonCommon, PopoverCommon } from 'src/common'
import ExampleItem from './components/ExampleItem/ExampleItem'
import { FormEditExample } from './components/FormEditExample/FormEditExample'
import './Examples.scss'

export const Examples = ({ examples, wordMeaningID, dictWordID }) => {
	return (
		<div>
			<div className="u-row">
				<PopoverCommon
					content={
						<FormEditExample
							wordMeaningID={wordMeaningID}
							dictWordID={dictWordID}
						/>
					}
					trigger="click"
				>
					<ButtonCommon size="small" ghost type="primary">
						+ Add more examples
					</ButtonCommon>
				</PopoverCommon>
			</div>

			{examples &&
				examples.map(item => (
					<ExampleItem
						key={item.id}
						id={item.id}
						example={item.example}
						translation={item.translation}
						wordMeaningID={wordMeaningID}
						dictWordID={dictWordID}
					/>
				))}
		</div>
	)
}

Examples.propTypes = {
	examples: PropTypes.string,
}

export default Examples
